import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#002F77"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#00D8D8"
      d="M96.5 113.8c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6m0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4"
    />
    <path
      fill="#D8FFFF"
      d="M101.5 11.26a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M6.57 58.36a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
    />
    <path
      fill="#00D8D8"
      d="m18.1 106.66 3.94-3.94c.59-.59.59-1.54 0-2.12s-1.54-.59-2.12 0l-3.94 3.94-3.94-3.94a1.49 1.49 0 0 0-2.12 0c-.58.59-.59 1.54 0 2.12l3.94 3.94-3.94 3.94a1.49 1.49 0 0 0 0 2.12c.29.29.68.44 1.06.44s.77-.15 1.06-.44l3.94-3.94 3.94 3.94c.29.29.68.44 1.06.44s.77-.15 1.06-.44c.59-.59.59-1.54 0-2.12z"
    />
    <path
      fill="#0597A3"
      d="M97.91 16.11h-81.4a4 4 0 0 0-4 4v9.88a4 4 0 0 0 4 4h81.4a4 4 0 0 0 4-4v-9.88a4 4 0 0 0-4-4"
    />
    <path fill="#00D8D8" d="M94.2 33.99H20.64v46.73H94.2z" />
    <path
      fill="#0597A3"
      d="M101.92 80.91H12.51c-1.24 0-2.25 1.01-2.25 2.25s1.01 2.25 2.25 2.25h42.65v10.71c-4.25 1.02-7.42 4.84-7.42 9.39 0 5.33 4.34 9.67 9.67 9.67s9.67-4.34 9.67-9.67c0-4.55-3.17-8.37-7.42-9.39V85.41h42.25c1.24 0 2.25-1.01 2.25-2.25s-1.01-2.25-2.25-2.25zm-39.33 24.6c0 2.85-2.32 5.17-5.17 5.17s-5.17-2.32-5.17-5.17 2.32-5.17 5.17-5.17 5.17 2.32 5.17 5.17"
    />
    <path
      fill="#001A43"
      d="M81.63 50.95H32.46c-1.24 0-2.25-1.01-2.25-2.25s1.01-2.25 2.25-2.25h49.17c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25M81.63 67.04H32.46c-1.24 0-2.25-1.01-2.25-2.25s1.01-2.25 2.25-2.25h49.17c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25"
    />
  </svg>
);
const SvgEnrichedIconRecordedTrainingBrand = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconRecordedTrainingBrand);
export default Memo;
